import DateRangeIcon from '@mui/icons-material/DateRange';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import {
    Grid,
    IconButton,
    InputAdornment,
    Popover,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { startOfYear } from 'date-fns';
import moment from 'moment';
import React, { useState } from 'react';
import { Calendar } from 'react-date-range';
import { useGetReportQuery } from '../../../../../app/Slices/SevenDayApiSlice';
import { CustomButton } from '../../../../../layout/styledcomponents/CustomButton';
import { CustomTextField } from '../../../../../layout/styledcomponents/CustomTextField';
import DropdownFilter from '../../../../../layout/styledcomponents/filters/Dropdown';
import TopModulesReportGraph from './TopModulesReportGraph';
import TopModulesListReport from './TopModulesReportList';

export default function TopModulesComponentPage() {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const [openCalendar1, setOpenCalendar1] = useState(false);
    const [anchorElCalendar1, setAnchorElCalendar1] =
        React.useState<null | HTMLElement>(null);
    const [openCalendar2, setOpenCalendar2] = useState(false);
    const [anchorElCalendar2, setAnchorElCalendar2] =
        React.useState<null | HTMLElement>(null);
    const [moduleNo, setTopModuleNo] = useState(5);
    const [fromDate, setFromDate] = useState(startOfYear(new Date()));
    const [toDate, setToDate] = useState(new Date());
    const [checked, setChecked] = React.useState(false);
    const theme = useTheme();

    //REPORT VIEW
    const graphView = (value: boolean | ((prevState: boolean) => boolean)) => {
        setChecked(value);
    };

    //GET REPORT
    const { data: getReport } = useGetReportQuery(
        `/reports/top-modules?from=${moment(fromDate).format(
            'YYYY-MM-DD',
        )}&to=${moment(toDate).format('YYYY-MM-DD')}&limit=${moduleNo}`,
    );

    const handleTopModuleNumber = (value: any) => {
        setTopModuleNo(value);
    };

    const handleCalendar1 = (event: React.MouseEvent<HTMLElement>) => {
        setOpenCalendar1(!openCalendar1);
        setAnchorElCalendar1(event.currentTarget);
    };

    const handleCalendar1Close = (event: React.MouseEvent<HTMLElement>) => {
        setOpenCalendar1(!openCalendar1);
        setAnchorElCalendar1(null);
    };

    const handleCalendar2 = (event: React.MouseEvent<HTMLElement>) => {
        setOpenCalendar2(!openCalendar2);
        setAnchorElCalendar2(event.currentTarget);
    };

    const handleCalendar2Close = (event: React.MouseEvent<HTMLElement>) => {
        setOpenCalendar2(!openCalendar2);
        setAnchorElCalendar2(null);
    };

    return (
        <Grid sx={{ marginTop: isMobile ? '30px' : '0px' }}>
            <Grid
                sx={{
                    textAlign: isMobile ? 'left' : 'right',
                    // backgroundColor: 'blue',
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                }}
            >
                <Grid
                    sx={{
                        width: '100%',
                        minHeight: 'auto',
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        alignItems: 'left',
                        // backgroundColor: 'yellow',
                    }}
                >
                    <Grid
                        sx={{
                            width: 'auto',
                            // backgroundColor: 'blue',
                            marginRight: isMobile ? '0px' : '15px',
                        }}
                    >
                        <CustomTextField
                            color='dark'
                            label='From'
                            fullWidth={isMobile}
                            value={moment(fromDate)?.format('DD/MM/YYYY')}
                            onClick={handleCalendar1}
                            // onChange={(item:any) => [setFromDate(item)]}
                            InputProps={{
                                //
                                style: {
                                    minHeight: '30px',
                                    maxHeight: '33px',
                                },
                                endAdornment: (
                                    <InputAdornment position='end'>
                                        <IconButton
                                            disableRipple
                                            onClick={handleCalendar1}
                                        >
                                            <DateRangeIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Popover
                            open={openCalendar1}
                            anchorEl={anchorElCalendar1}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            onClose={handleCalendar1Close}
                        >
                            <Calendar
                                onChange={(item) => [setFromDate(item)]}
                                date={fromDate}
                                weekStartsOn={1}
                                rangeColors={[theme.palette.info.main]}
                                color={theme.palette.textAccent.main}
                            />
                        </Popover>
                    </Grid>
                    <Grid
                        sx={{
                            width: 'auto',
                            marginRight: isMobile ? '0px' : '15px',
                            marginTop: isMobile ? '10px' : '0px',
                        }}
                    >
                        <CustomTextField
                            label='To'
                            color='dark'
                            fullWidth={isMobile}
                            value={moment(toDate)?.format('DD/MM/YYYY')}
                            onClick={handleCalendar2}
                            InputProps={{
                                style: {
                                    minHeight: '30px',
                                    maxHeight: '33px',
                                },
                                endAdornment: (
                                    <InputAdornment position='end'>
                                        <IconButton
                                            disableRipple
                                            onClick={handleCalendar2}
                                        >
                                            <DateRangeIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <Popover
                            open={openCalendar2}
                            anchorEl={anchorElCalendar2}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            onClose={handleCalendar2Close}
                        >
                            <Calendar
                                onChange={(item) => [setToDate(item)]}
                                date={toDate}
                                weekStartsOn={1}
                                rangeColors={[theme.palette.info.main]}
                                color={theme.palette.info.main}
                            />
                        </Popover>
                    </Grid>
                    <Grid
                        sx={{
                            width: 'auto',
                            marginRight: isMobile ? '0px' : '15px',
                            marginTop: isMobile ? '10px' : '0px',
                        }}
                    >
                        {' '}
                        <DropdownFilter
                            id={'topExperiencesNo'}
                            options={[
                                // { value: 'All', label: 'All' },
                                { value: 1, label: '1' },
                                { value: 2, label: '2' },
                                { value: 3, label: '3' },
                                { value: 4, label: '4' },
                                { value: 5, label: '5' },
                                { value: 6, label: '6' },
                                { value: 7, label: '7' },
                                { value: 8, label: '8' },
                                { value: 9, label: '9' },
                                { value: 10, label: '10' },
                            ]}
                            handleChange={handleTopModuleNumber}
                            selectedValue={
                                <Grid
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            marginRight: '5px',
                                        }}
                                    >
                                        Top:
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                        }}
                                    >
                                        {moduleNo}
                                    </Typography>
                                </Grid>
                            }
                            backgroundColor={theme.palette.neutral.main}
                            border={theme.palette.midGrey.main}
                            minHeight={'30px'}
                            maxHeight={'33px'}
                        />
                    </Grid>
                    {/* <Grid sx={{ height: '100%' }}></Grid> */}
                </Grid>

                <Grid
                    sx={{
                        width: isMobile ? '100%' : '50%',
                        minHeight: 'auto',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        paddingBottom: 1,
                    }}
                >
                    <Grid
                        sx={{
                            width: 'auto',
                        }}
                    >
                        {checked === true ? (
                            <CustomButton
                                disableRipple
                                variant='outlined'
                                color='primary'
                                onClick={() => graphView(false)}
                            >
                                <FormatListBulletedIcon fontSize='small' />
                            </CustomButton>
                        ) : (
                            <CustomButton
                                disableRipple
                                variant='outlined'
                                color='primary'
                                onClick={() => graphView(true)}
                            >
                                <EqualizerIcon fontSize='small' />
                            </CustomButton>
                        )}
                    </Grid>
                </Grid>
            </Grid>
            <Grid>
                {checked === true ? (
                    <TopModulesReportGraph data={getReport} />
                ) : (
                    <TopModulesListReport data={getReport} />
                )}
            </Grid>
        </Grid>
    );
}
